/**
 * EditProductDialog — admin dialog for editing an existing product.
 */
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { FloppyDiskBack } from "@phosphor-icons/react";

export function EditProductDialog({ editingProduct, setEditingProduct, editForm, setEditForm, onSave }) {
  return (
    <Dialog open={!!editingProduct} onOpenChange={(open) => !open && setEditingProduct(null)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading tracking-wide">EDIT PRODUCT</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          <div>
            <Label>Product Name</Label>
            <Input
              value={editForm.name}
              onChange={(e) => setEditForm(p => ({ ...p, name: e.target.value }))}
            />
          </div>
          <div>
            <Label>Unit Definition</Label>
            <Input
              value={editForm.unit}
              onChange={(e) => setEditForm(p => ({ ...p, unit: e.target.value }))}
              placeholder="e.g., 1 CS = 12 EA"
            />
            <p className="text-xs text-muted-foreground mt-1">
              Examples: "1 CS = 12 EA", "1 CS = 20lb", "1 CS = 5 x 2.2lb"
            </p>
          </div>
          <div>
            <Label>Price per Case ($)</Label>
            <Input
              type="number"
              value={editForm.price}
              onChange={(e) => setEditForm(p => ({ ...p, price: e.target.value }))}
              min="0"
              step="0.01"
            />
          </div>
          <div>
            <Label>Category</Label>
            <Input
              value={editForm.category}
              onChange={(e) => setEditForm(p => ({ ...p, category: e.target.value }))}
            />
          </div>
        </div>
        <DialogFooter className="mt-6">
          <Button variant="outline" onClick={() => setEditingProduct(null)}>Cancel</Button>
          <Button onClick={onSave} className="bg-primary">
            <FloppyDiskBack size={16} className="mr-2" />
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
